<div class="ui modal general-upgrade-modal">
  <i class="close icon"><svg   data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.01 30.01"><path d="M16.38 15.01L29.73 1.66A1 1 0 0 0 28.36.29L15.01 13.64 1.66.29A1 1 0 0 0 .29 1.66l13.35 13.35L.29 28.36a1 1 0 0 0 1.37 1.37l13.35-13.35 13.35 13.35a1 1 0 0 0 1.37-1.37z" fill="#757575" fill-rule="evenodd"/></svg></i>
  <general-upgrade
    #generalUpgradeViewChild
    *ngIf="componentName === 'general-upgrade'"
    [featureKey]="featureKeyName"
    [getQuoteproductInterest]="getQuoteProductInterestKey"
  ></general-upgrade>

  <feature-upgrade
    #featureUpgradeViewChild
    *ngIf="componentName === 'feature-upgrade'"
    [featureKey]="featureKeyName"
    [getQuoteproductInterest]="getQuoteProductInterestKey"
  ></feature-upgrade>

  <devices-upsell
    #devicesUpgradeViewChild
    *ngIf="componentName === 'devices-upsell'"
    [featureKey]="featureKeyName"
    [getQuoteproductInterest]="getQuoteProductInterestKey"
  ></devices-upsell>
</div>
